export const getQueryData = (compareList: string) => {
  try {
    if (compareList.includes('A')) {
      const parts = compareList.split('/');
      const ids: Array<string> = [];
      for (let idx = 1; idx < parts.length; idx++) {
        if (parts[idx]) {
          ids.push(`PY-A-${parts[idx]}`);
        }
      }
      return [...ids];
    } else if (compareList.includes('P')) {
      const parts = compareList.split('/');
      const ids: Array<string> = [];
      for (let idx = 1; idx < parts.length; idx++) {
        if (parts[idx]) {
          ids.push(`PY-P-${parts[idx]}`);
        }
      }
      return [...ids];
    } else if (compareList.includes('G')) {
      const parts = compareList.split('/');
      const ids: Array<string> = [];
      for (let idx = 1; idx < parts.length; idx++) {
        if (parts[idx]) {
          ids.push(`PY-${parts[idx]}`);
        }
      }
      return [...ids];
    }
    return [];
  } catch (error) {
    console.log('cant get compareListCookie', error);
    return [];
  }
};

export const extractItemNumber = (productCode: string): string => {
  const parts = productCode.split('-');
  return parts[parts.length - 1];
};

export const getProductType = (id: string): string => {
  const parts = id.split('-');
  if (parts.length >= 2 && parts[1].match(/^[A-Z]$/)) {
    return `${parts[0]}-${parts[1]}-`; // PY-A-, PY-P-
  }
  return `${parts[0]}-`; // PY-
};

export const extractFirstSegment = (productCode: string): string => {
  const parts = productCode.split('-');
  if (parts.length >= 2 && parts[1].match(/^[A-Z]$/)) {
    // For PY-A-12345 format, return the third part (12345)
    return parts[2] || '';
  }
  // For PY-5775 format, return the second part (5775)
  return parts[1] || '';
};
